import axios from 'axios';
import redirectTo from '../utils/RedirectUtil'


export const getPaymentInfo = (paymentRef = null, lang = "en") => {

    const instance = axios.create({
        baseURL: window.PAYMENT_URL,
        headers: {
            'accept-language': lang,
        }
    });

    return instance.request({
        url: `/validation/${paymentRef}/info`,
        method: 'GET'
    });
};

export const postAccountSelection = (paymentRef = null, account = null) => {

    const instance = axios.create({
        baseURL: window.PAYMENT_URL,
        headers: {
            'content-type': 'application/json',
        }
    });

    return instance.request({
        url: `/validation/${paymentRef}/select-account`,
        method: 'POST',
        data: JSON.stringify({iban: account})
    });
};

export const postScaConfirmation = (paymentRef = null) => {

    const instance = axios.create({
        baseURL: window.PAYMENT_URL,
        headers: {
            'content-type': 'application/json',
        }
    });

    return instance.request({
        url: `/validation/${paymentRef}/confirm-exemption`,
        method: 'POST',
        data: JSON.stringify({scaHint: "scaExemption"})
    });
};

export const handleServerError = (error, language, history) => {
    if (error) {
        console.log(error)
        // INVALID RESPONSE RECEIVED FROM SERVER
        redirectTo(history, `/${language}/result?status=fail`)
    }
 }